import store from "../redux/store";
import { history } from "../../src/index";
import { logout } from "../helper/auth-helper";
import { authSlice } from "../redux/slices/authSlice";
import { ROLE_TENANT_ADMIN, ROLE_GLOBAL_ADMIN, ROLE_CS_ADMIN, ROLE_USER, ROLE_ATTRACTION, ROLE_SOURCING, ROLE_ASSESMENT, ROLE_ASSESMENT_SENIOR, ROLE_SCREENING } from "../constants";
import { getTenantRole } from "../helper/role-helper";
import { TokenStorage } from "../helper/token-storage";

export const authenticationIsValid = (
  token: string | null | undefined,
  userId: string | null | undefined,
  expiration: number | null | undefined
): boolean => {
  if ((!token && !userId) || !expiration) return false;
  const expirationTime = expiration < 1_000_000_000_000 ? expiration * 1000 : expiration;
  return expirationTime >= Date.now();
};

export const userIsAuth = (logOutIfFalse: boolean = false): boolean => {
  const state = store.getState();
  const adB2C = new TokenStorage().getAzureAdB2C();
  const token = state.auth.token || adB2C?.token;
  const userId = state.auth.userId || adB2C?.userId;
  const expiration = state.auth.tokenExpiry || adB2C?.tokenExpiry;
  const isLoggedIn = authenticationIsValid(token, userId, expiration);

  if (!isLoggedIn && logOutIfFalse) {
    logout(history, "login.error", store.dispatch, () => {
      store.dispatch(authSlice.actions.auth(null));
    });
  }
  return isLoggedIn;
};

export const checkRoleAndPermissions = (tenants: any[], tenantAlias?: string, roles?: string[], permissions?: string[], selectedUserProfile?: string) => {
  const tenant = tenants?.find((tenantFind: any) => tenantFind.alias === tenantAlias);
  const isSuperAdmin = getTenantRole(tenants, tenantAlias) === ROLE_GLOBAL_ADMIN;
  const isAdmin = getTenantRole(tenants, tenantAlias) === ROLE_TENANT_ADMIN;
  const isUser = getTenantRole(tenants, tenantAlias, selectedUserProfile) === ROLE_USER;
  const isRoleAttraction = getTenantRole(tenants, tenantAlias, selectedUserProfile) === ROLE_ATTRACTION;
  const isRoleSourcing = getTenantRole(tenants, tenantAlias, selectedUserProfile) === ROLE_SOURCING;
  const isRoleScreening = getTenantRole(tenants, tenantAlias, selectedUserProfile) === ROLE_SCREENING;
  const isRoleAssesment = getTenantRole(tenants, tenantAlias, selectedUserProfile) === ROLE_ASSESMENT;
  const isRoleAssesmentSenior = getTenantRole(tenants, tenantAlias, selectedUserProfile) === ROLE_ASSESMENT_SENIOR;

  let havePermission = true;
  // Check roles
  if (roles) {
    const haveSuperAdminPermission = roles.find((role: any) => role === ROLE_GLOBAL_ADMIN) && isSuperAdmin;
    const haveAdminPermission = roles.find((role: any) => role === ROLE_TENANT_ADMIN) && isAdmin;
    const haveCSADminPermission = roles.find((role: any) => role === ROLE_CS_ADMIN) && isAdmin;
    const haveUserPermission = roles.find((role: any) => role === ROLE_USER) && isUser;
    const haveAttractionPermission = roles.find((role: any) => role === ROLE_ATTRACTION) && isRoleAttraction;
    const haveSourcingPermission = roles.find((role: any) => role === ROLE_SOURCING) && isRoleSourcing;
    const haveScreeningPermission = roles.find((role: any) => role === ROLE_SCREENING) && isRoleScreening;
    const haveAssesmentPermission = roles.find((role: any) => role === ROLE_ASSESMENT) && isRoleAssesment;
    const haveAssesmentSeniorPermission = roles.find((role: any) => role === ROLE_ASSESMENT_SENIOR) && isRoleAssesmentSenior;
    if (
      !(
        haveSuperAdminPermission ||
        haveAdminPermission ||
        haveCSADminPermission ||
        haveUserPermission ||
        haveAttractionPermission ||
        haveSourcingPermission ||
        haveScreeningPermission ||
        haveAssesmentPermission ||
        haveAssesmentSeniorPermission
      )
    )
      havePermission = false;
  }
  // Check permissions
  if (permissions) {
    permissions.forEach((permission) => {
      if (permission && tenant?.permissions?.adminPanel && !tenant.permissions.adminPanel[permission]) havePermission = false;
    });
  }
  return havePermission;
};
